import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box, ListItem, Typography, Checkbox } from '@mui/material'
import { CircularProgress, IconButton, Tooltip } from '@mui/material'
import AttachFileIcon from '@mui/icons-material/AttachFile'

import { requests } from '../../../../core/ajax'
import { downloadFile } from '../../../../core/utils'

const MANAGER_PROFILES = {
  gestor: 'gestor',
  delegado: 'delegado',
  e_commerce: 'e_commerce',
  call_center: 'call_center',
}

const INSTALLER_PROFILES = {
  instalador: 'instalador',
  administrador: 'administrador',
  gremio: 'gremio',
}

const isOwnMessage = (ownProfile, messageProfile) => {
  if (ownProfile === messageProfile) {
    return true
  } else {
    return false
  }
}

export const MessageItem = ({ profile, markAsRead, message, checkeable }) => {
  const { formatDate, formatTime } = useIntl()
  const { getById } = requests
  const isOwn = isOwnMessage(profile, message.tipo_perfil_remitente)
  const [loading, setLoading] = useState(false)

  const listItemSx = (theme) => ({
    maxWidth: '87%',
    marginRight: '10%',
    marginLeft: '3%',
    marginBottom: '6px',
    backgroundColor: theme.palette.grey[100],
    borderRadius: '8px',
    boxShadow: !message.leido ? `-4px 4px 3px ${theme.palette.grey[200]}` : 'none',
  })

  const listItemOwnSx = {
    maxWidth: '87%',
    marginLeft: '10%',
    marginRight: '3%',
    marginBottom: '6px',
    backgroundColor: 'common.white',
    borderRadius: '8px',
    border: '2px solid',
    borderColor: 'primary.main',
  }

  const handleDownloadFile = (id) => {
    setLoading(true)
    getById('/documento', id)
      .then(({ data }) => {
        downloadFile(data['documento'], data['extension'], data['nombre'])
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  const PrimaryItem = () => (
    <Box display="flex">
      <Box flex={1}>
        <Typography component="span" variant="body2" color="text.primary">
          {message.nombre ? `${message.nombre} - ` : ''}
          {`${formatDate(message.fecha)} ${formatTime(message.fecha)}`}
        </Typography>
      </Box>
      {message.documentos.length ? (
        <IconButton
          size="small"
          onClick={() => handleDownloadFile(message.documentos[0].documento_id)}
          disabled={loading}
        >
          {loading ? <CircularProgress size={18} /> : <AttachFileIcon fontSize="inherit" />}
        </IconButton>
      ) : null}
    </Box>
  )

  const SecondaryItem = () => (
    <>
      <Typography component="span" variant="body2" color="text.primary">
        {message.mensaje}
      </Typography>
      {!isOwn && !message.leido ? (
        <Box textAlign="right">
          <Tooltip arrow title="Marcar como leido">
            <Checkbox
              edge="end"
              size="small"
              onChange={() => markAsRead(message.id)}
              checked={message.leido}
            />
          </Tooltip>
        </Box>
      ) : null}
    </>
  )

  return (
    <ListItem sx={isOwn ? listItemOwnSx : listItemSx}>
      <Box width="100%">
        <PrimaryItem />
        <SecondaryItem />
      </Box>
    </ListItem>
  )
}
